import type { SxProps, Theme } from '../../themes/themes';

export const getStyles = (theme: Theme, customLogoUrl = '', customFlyoutLogoUrl = ''): { [key: string]: SxProps } => {
  return {
    backgroundDefault: {
      backgroundColor: theme.palette.background['default'],
    },
    backgroundGrey: {
      backgroundColor: theme.palette.grey['100'],
    },
    searchButton: {
      color: theme.palette.primary['contrastText'],
      [theme.breakpoints.up('md')]: {
        marginRight: theme.spacing(8),
      },

      '& .MuiButtonBase-root': {
        [theme.breakpoints.up('xs')]: {
          borderRadius: theme.spacing(8),
        },

        [theme.breakpoints.up('sm')]: {
          borderRadius: theme.spacing(8),
        },
        [theme.breakpoints.up('md')]: {
          fontSize: theme.spacing(6),
          height: theme.spacing(9),
          width: theme.spacing(9),
          borderRadius: theme.spacing(9),
        },
        [theme.breakpoints.up('lg')]: {
          fontSize: theme.spacing(6),
          height: theme.spacing(10),
          width: theme.spacing(10),
          borderRadius: theme.spacing(10),
        },
        ':focus-visible': {
          boxShadow: `inset 0px 0px 0px 1px ${theme.palette.action.focus}`,
          outline: `2px solid ${theme.palette.primary['contrastText']}`,
          outlineOffset: '-3px',
          color: theme.palette.primary['contrastText'],
        },
        ':active': {
          background: theme.palette.primary['darker'],
        },
      },
    },
    mobileHidden: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    desktopHidden: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    levelOne: {
      marginTop: 0,
      marginBottom: 0,
      paddingTop: 2,
      paddingBottom: 2,
      justifyContent: 'center',
      width: '100%',
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.primary['dark'],
    },
    levelTwo: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',

      marginTop: 0,
      marginBottom: 0,
    },
    levelThree: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      height: 'auto',

      marginTop: 0,
      marginBottom: 0,
    },
    hidden: {
      visibility: 'hidden',
    },
    headerIconContainer: {
      display: 'flex',
      alignItems: 'center',
      width: { xs: 'auto', md: '96px', lg: '300px' },
      paddingY: { xs: 0, lg: 3 },
    },
    headerIcon: {
      height: '100%',
      width: '100%',

      '& .MuiSvgIcon-root': {
        fontSize: theme.spacing(8),
        color: theme.palette.text.primary,
        display: 'block',
        [theme.breakpoints.up('lg')]: { display: 'none' },
      },

      '& img': {
        [theme.breakpoints.up('lg')]: { display: 'none', opacity: 0 },
      },
    },
    headerIconDefault: {
      [theme.breakpoints.up('lg')]: {
        backgroundImage: customLogoUrl ? `url('${customLogoUrl}')` : `url('/assets/tenant_header_logo.svg')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left',
      },
    },
    headerIconFlyout: {
      [theme.breakpoints.up('lg')]: {
        backgroundImage: customLogoUrl
          ? `url('${customFlyoutLogoUrl}')`
          : `url('/assets/tenant_header_logo_flyout.svg')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left',
      },
    },

    skipToMainContentLink: {
      display: 'flex',
      justifyContent: 'center',
      position: 'absolute',
      background: 'white',
      zIndex: 1111,
      marginLeft: 'auto',
      marginRight: 'auto',
      left: 0,
      right: 0,
      textAlign: 'center',
      padding: '6px 18px 6px 18px',
      borderBottomLeftRadius: theme.spacing(2),
      borderBottomRightRadius: theme.spacing(2),
      width: '155px',
      opacity: 0,
      pointerEvents: 'none',
      ':focus': { opacity: 1 },
      ':focus-visible': {
        outline: 'none',
        pointerEvents: 'auto',
        borderColor: `${theme.palette.border.defaultFocus}`,
        boxShadow: `0 0 0 2px ${theme.palette.border.defaultFocus}`,
      },
      ':hover': {
        textDecoration: 'underline',
        color: `${theme.palette.labeling.secondaryDefault}`,
      },
      ':active': {
        textDecoration: 'underline',
        color: `${theme.palette.labeling.secondaryDefault}`,
      },
      [theme.breakpoints.up('sm')]: {
        padding: '9px 24px 9px 24px',
        width: '194px',
      },
    },
  };
};
